<template>
  <v-app style="background:white;">
    <!-- 로그인된 경우에만 헤더 보여주기 -->
    <app-header v-if="isLoggedIn && !isLoginPageComputed" />

    <!-- main -->
    <v-main>
      <router-view v-if="authInitialized || isLoginPageComputed" />
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from './components/layout/AppHeader'
import { auth, onAuthStateChanged, signOut } from '@/datasources/firebase'
const LOGOUT_TIME = 60 * 60 * 24000 * 5; // 24시간을 밀리초로 정의 (5일)

export default {
  name: 'App',
  components: {
    AppHeader,
  },
  computed: {
    isLoginPageComputed() {
      // 현재 라우트의 이름이 'Login'과 일치하면 true를 반환
      return this.$route.name === 'Login'
    }
  },
  data() {
    return {
      isLoggedIn: false, // Firebase 인증 상태 (UI 제어용)
      authInitialized: false // Firebase 인증 초기화 완료 여부 (라우터 가드 등에서 활용)
    };
  },
  created() {
    // Firebase 인증 상태 변화 리스너 설정 (앱 로드 시 자동 로그인 유지 확인)
    onAuthStateChanged(auth, user => {
      if (user) {
        this.isLoggedIn = true; // 사용자 객체가 있으면 로그인 상태
        this.authInitialized = true // 인증 상태가 확인되면 true로 설정
        // 앱이 처음 로드되고 Firebase 인증 상태가 확정된 후,
        // 1시간 자동 로그아웃 체크 로직을 실행합니다.
        this.checkAndForceLogout(auth);
      }
    });
  },
  mounted() {
    // 1. 사용자 활동 감지 리스너 등록
    // document.addEventListener('mousemove', this.updateLastActivityTime);
    document.addEventListener('keydown', this.updateLastActivityTime);
    document.addEventListener('click', this.updateLastActivityTime);

    // 2. 로그아웃 체크 함수 주기적 호출
    // 매 1분마다 체크 (필요에 따라 조절)
    this.logoutCheckInterval = setInterval(() => {
      // Firebase auth 인스턴스를 전달해야 함 (예: getAuth() 또는 props/provide/inject로 받기)
      this.checkAndForceLogout(this.$firebaseAuthInstance); // authInstance는 앱 초기화 시점의 Firebase Auth 객체
    }, 60 * 1000); // 1분 = 60000ms
  },
  beforeUnmount() {
    // 컴포넌트 언마운트 시 리스너 및 인터벌 해제
    // document.removeEventListener('mousemove', this.updateLastActivityTime);
    document.removeEventListener('keydown', this.updateLastActivityTime);
    document.removeEventListener('click', this.updateLastActivityTime);
    clearInterval(this.logoutCheckInterval);
  },
  methods: {
    updateLastActivityTime() {
      if (this.isLoggedIn) { // 로그인 상태일 때만 s갱신
        localStorage.setItem('lastLoginTime', Date.now().toString());
      }
    },
    checkAndForceLogout(authInstance) {
      if (!this.isLoggedIn) {
        // 로그아웃 상태면 저장된 시간 정보 제거
        localStorage.removeItem('lastLoginTime');
        return;
      }

      const lastLoginTime = localStorage.getItem('lastLoginTime');

      if (lastLoginTime) {
        const loginTimestamp = parseInt(lastLoginTime, 10);
        const currentTime = Date.now();

        if (navigator.onLine && currentTime - loginTimestamp > LOGOUT_TIME) {
          console.log('1시간이 경과하여 자동 로그아웃됩니다.');
          signOut(authInstance) // Firebase 로그아웃
            .then(() => {
              localStorage.removeItem('lastLoginTime'); // 저장된 시간 제거
              if (this.$router.currentRoute.path !== '/login') { // 이미 로그인 페이지가 아니면 이동
                  this.$router.push('/login'); // 로그인 페이지로 리다이렉트
              }
            })
            .catch(error => {
              console.error('자동 로그아웃 중 오류 발생:', error);
              alert('자동 로그아웃 중 오류가 발생했습니다.');
            });
        }
      } else {
        // lastLoginTime이 없는데 현재 로그인 상태인 경우 (예: 브라우저 캐시 삭제 후 재접속)
        // 현재 시간을 로그인 시간으로 간주하여 새로 저장
        localStorage.setItem('lastLoginTime', Date.now().toString());
      }
    },
    // ... (handleLogout 메서드 등 기존 메서드 유지)
  }
}
</script>
